import {
  DOCUMENT_DESER,
  createDocumentMap,
  documentJsonKeyExtractor,
  type DocumentMap,
} from "../../tastyworks/document"
import type HttpClient from "../../tastyworks/http"
import { toArrayMap, type SingleResponse } from "../../tastyworks/response"

export class GeneralDocumentService {
  constructor(private readonly baseHttpClient: HttpClient) {}

  readonly indexBySlug = async (
    regulatoryDomain: string
  ): Promise<SingleResponse<DocumentMap>> => {
    const documentMap = createDocumentMap()
    const response = await this.baseHttpClient.index(
      documentMap,
      DOCUMENT_DESER.update,
      documentJsonKeyExtractor,
      "documents",
      { regulatoryDomain }
    )

    return toArrayMap(response, documentMap)
  }
}
